import { client, formatQueryParams } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = (params) =>
  client.billerLogos.query(formatQueryParams(params));
